
import {
  getStepsToJoinCampaign,
  JOIN_CAMPAIGN_STEP_TYPE,
} from '@store:web/components/pages/StoryPage/SpecificStory/ui/StepsToJoinCampaign/getStepsToJoinCampaign';

import type {
  StepsToJoinCampaignStep,
} from '../ui/StepsToJoinCampaign/StepsToJoinCampaign';
import StepsToJoinCampaign from '../ui/StepsToJoinCampaign/StepsToJoinCampaign';
import { FIVE_TARS_STORY_URLS } from './data';

const stepsToJoinAutoLayerCampaign: StepsToJoinCampaignStep[] = [
  ...getStepsToJoinCampaign([
    JOIN_CAMPAIGN_STEP_TYPE.REGISTER_MAGIC_STORE_ACCOUNT,
    JOIN_CAMPAIGN_STEP_TYPE.ADD_EVM_WALLET,
    JOIN_CAMPAIGN_STEP_TYPE.USERNAME_AND_EMAIL,
  ]),
  {
    id: 'proof',
    title: 'Complete Proof-of-Humanity verification',
    type: JOIN_CAMPAIGN_STEP_TYPE.VERIFY_HUMANITY,
  },
  ...getStepsToJoinCampaign([
    JOIN_CAMPAIGN_STEP_TYPE.VISIT_CAMPAIGN_PAGE,
    JOIN_CAMPAIGN_STEP_TYPE.MONITOR_LEADERBOARD,
  ]),
  {
    id: 'claim',
    title: 'Rewards will be claimed through the 5TARS Launchpad',
  },
];

const StepToJoin5tarsCampaign = () => {
  return (
    <StepsToJoinCampaign
      campaignUrl={FIVE_TARS_STORY_URLS.campaign}
      steps={stepsToJoinAutoLayerCampaign}
      className="story-prose-none"
    />
  );
};

export default StepToJoin5tarsCampaign;
